import React from 'react';
// Final Thank You Email for unregistered participants
const TwentyOneStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    photo_access_link,
    upcoming_conference_link,
    your_name,
    contact_details,
  } = values;

  return (
    <div>
      <p>
        We sincerely appreciate your interest in{' '}
        <strong>
          {' '}
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}
        </strong>
        . Although we missed having you join us this time, we wanted to share
        some memorable moments from the event with you.
      </p>

      <p>
        You can access the photos here:{' '}
        {photo_access_link ? (
          <a href={photo_access_link} target="_blank" rel="noopener noreferrer">
            {photo_access_link}
          </a>
        ) : (
          `[Photos Access Link]`
        )}
        .
      </p>
      <p>
        While this event has concluded,{' '}
        <strong>
          you still have the chance to join our future conferences
        </strong>
        . We would love to have you with us next time. You can learn more and
        register for our upcoming conference here:{' '}
        {upcoming_conference_link ? (
          <a
            href={upcoming_conference_link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {upcoming_conference_link}
          </a>
        ) : (
          `[Upcoming
        Conference Link]`
        )}
        .
      </p>

      <p>
        Thank you once again for your interest, and we hope to see you at our
        next event!
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default TwentyOneStepWhatsappTemplate;
